import styled from 'styled-components';
import colors from '@/constants/colors';
import AppLink from '@/routing/helpers/AppLink';

export default function NotFoundScreen() {
  return (
    <Container>
      <Code>404</Code>

      <Title>Page Not Found</Title>

      <Subtitle>
        We couldn’t find the page you’re looking for.
        <br />
        It might have been moved or doesn’t exist.
      </Subtitle>

      <AppLink path="user_home" className="btn btn-sm btn-info mr-2">
        Back to Home
      </AppLink>
    </Container>
  );
}

const Container = styled.div`
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
`;

const Code = styled.div`
  font-size: 180px;
  font-weight: 800;
  line-height: 1;
  color: ${colors.primary};
  user-select: none;
`;

const Title = styled.h1`
  margin-top: -20px;
  font-size: 32px;
  font-weight: 700;
  color: ${colors.primary};
`;

const Subtitle = styled.p`
  margin-top: 12px;
  max-width: 420px;
  font-size: 16px;
  line-height: 1.6;
  color: ${colors.primary};
`;
